import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchTickets = createAsyncThunk('tickets/fetchAll', async (params) => {
  const { data } = await client.get('/tickets/', { params });
  return data;
});

export const fetchTicket = createAsyncThunk('tickets/fetchOne', async (id) => {
  const { data } = await client.get(`/tickets/${id}/`);
  return data;
});

export const createTicket = createAsyncThunk('tickets/create', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await client.post('/tickets/', payload);
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

export const transitionTicket = createAsyncThunk('tickets/transition', async ({ id, transition, notes, fields }, { rejectWithValue }) => {
  try {
    const { data } = await client.post(`/tickets/${id}/transition/`, { new_status: transition, notes: notes || '', fields: fields || {} });
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

export const signoffTicket = createAsyncThunk('tickets/signoff', async (id, { rejectWithValue }) => {
  try {
    const { data } = await client.post(`/tickets/${id}/signoff/`);
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState: { list: [], current: null, total: 0, loading: false, error: null },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTickets.pending, state => { state.loading = true; })
      .addCase(fetchTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.results || action.payload;
        state.total = action.payload.count || action.payload.length;
      })
      .addCase(fetchTicket.fulfilled, (state, action) => { state.current = action.payload; })
      .addCase(transitionTicket.fulfilled, (state, action) => { state.current = action.payload; })
      .addCase(signoffTicket.fulfilled, (state, action) => { state.current = action.payload; });
  }
});

export default ticketsSlice.reducer;
